module.exports = __webpack_public_path__ + "img/jp.11e9ef0d.svg";